import { render, staticRenderFns } from "./createBidZB.vue?vue&type=template&id=0e2f1348&"
import script from "./createBidZB.vue?vue&type=script&lang=js&"
export * from "./createBidZB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./createBidZB.vue?vue&type=custom&index=0&blockType=strong"
if (typeof block0 === 'function') block0(component)

export default component.exports